'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Building2 } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide17bSchoolValue2({ id, registerRef }: Props) {
  const cards = [
    {
      title: 'Có nội dung tổng kết rõ ràng để truyền thông và báo cáo',
      desc: 'Tri An Green Travel có thể phối hợp để nhà trường có phần tổng kết mạch lạc, dễ đăng tải và thuận tiện hơn trong việc làm báo cáo hoạt động.',
    },
    {
      title: 'Có số liệu đầu ra cụ thể',
      desc: 'Nhà trường có thể sử dụng các đầu ra như số lượng sinh viên tham gia, số nhóm tham gia, số nội dung truyền thông được tạo ra, số hình ảnh/video recap, số chứng nhận đã trao và kết quả hoạt động tại điểm để tổng hợp và báo cáo ra hiệu quả chương trình.',
    },
    {
      title: 'Được đồng hành truyền thông cùng Tri An Green Travel',
      desc: 'Nhà trường không chỉ là đơn vị phối hợp tổ chức, mà còn được xuất hiện như một đối tác đồng hành trong hành trình truyền thông của chương trình, góp phần tăng độ nhận diện tích cực trong các hoạt động vì cộng đồng và phát triển sinh viên.',
    },
    {
      title: 'Được ghi nhận là đơn vị phối hợp chương trình',
      desc: 'Nhà trường / Đoàn – Hội có thể được nhắc đến như một đơn vị đồng hành cùng một chương trình xanh, có ý nghĩa, có sức lan tỏa và có giá trị xã hội rõ ràng.',
    },
  ];

  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#f5f0e8]">
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-20 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-3">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[rgba(26,74,42,0.1)] border border-[rgba(26,74,42,0.2)] mb-4">
            <Building2 size={12} className="text-[#1a4a2a]" />
            <span className="text-[11px] font-700 uppercase tracking-widest text-[#1a4a2a] font-body">Dành cho nhà trường / Đoàn – Hội</span>
          </div>
          <h2 className="font-display font-800 text-[clamp(26px,4vw,52px)] leading-[1.1] text-[#1a4a2a] tracking-tight">
            Quyền lợi dành cho nhà trường / Đoàn – Hội
          </h2>
        </div>

        <div className="fade-in-up mb-10">
          <div className="w-[60px] h-[3px] bg-[#1a4a2a] rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 fade-in-up">
          {cards.map((card, i) => (
            <div
              key={`school17b-${i}`}
              className="rounded-2xl bg-[rgba(200,220,200,0.35)] border border-[rgba(26,74,42,0.12)] p-7 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
            >
              <h3 className="font-display font-700 text-[17px] text-[#1a4a2a] mb-3 leading-snug">{card.title}</h3>
              <p className="font-body text-[14px] text-[#3a5a3a] leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </SlideWrapper>
  );
}
